import { Component } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

// the second parameter 'fr' is optional
registerLocaleData(localeEs, 'es-ES');
registerLocaleData(localeEs, 'es');

@Component({
    selector: 'convfact-app',
    template: `<router-outlet></router-outlet>`,
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {

}